import React from 'react'

import { Button, ButtonColorVariant, Spinner, Color } from '@gousto-internal/citrus-react'
import { browserHistory } from 'react-router'

import css from './BottomButton.css'

type BottomButtonBaseProps = {
  children: React.ReactNode
  color: 'primary' | 'secondary'
  disabled?: boolean
  fullWidth?: boolean
  isLoading?: boolean
  testingSelector?: string
}

// One of url or onClick is required
type BottomButtonProps = BottomButtonBaseProps &
  ({ url: string; onClick?: () => void } | { url?: never; onClick: () => void })

const BottomButton: React.FC<BottomButtonProps> = ({
  children,
  color,
  onClick,
  url,
  fullWidth = false,
  disabled = false,
  isLoading = false,
  testingSelector,
}) => {
  const colorVariant =
    color === 'primary' ? ButtonColorVariant.Primary : ButtonColorVariant.Secondary
  const spinnerColor = color === 'primary' ? Color.White : Color.Secondary_400

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    if (url) {
      browserHistory.push(url)
    }
  }

  return (
    <Button
      className={fullWidth ? css.buttonFullWidth : css.button}
      colorVariant={colorVariant}
      onClick={handleClick}
      data-testing={testingSelector}
      data-testid={testingSelector}
      disabled={isLoading || disabled}
      width={fullWidth ? '100%' : undefined}
    >
      {isLoading ? <Spinner color={spinnerColor} size={6} /> : children}
    </Button>
  )
}

export { BottomButton }
